import { type PersonSearch } from '@reliance/types/models/PersonSearch';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const personSearch = (centralApi: ApiService) => ({
  index: (
    params: QueryParams = {},
  ): Promise<PaginatedResponse<PersonSearch>> => {
    return centralApi.get('/person-search', { params });
  },
  get: (id: number): Promise<PersonSearch> => {
    return centralApi.get(`/person-search/${id}`);
  },
  post: (
    data: object,
  ): Promise<{ success: boolean; id: number; personSearch: PersonSearch }> => {
    return centralApi.post('/person-search', data);
  },
  getByAni: (ani: string): Promise<PersonSearch> => {
    return centralApi.get(`/person-search/by-ani/${ani}`);
  },
});
